'use client';

import { UserButton } from '@clerk/nextjs';
import { useSession } from '@/core/auth/use-session';
import { SignedIn } from '@clerk/nextjs';
import { Mascot } from '@spikemark/ui/components/mascot';
import { User2Icon } from 'lucide-react';
import { useRef, useState } from 'react';
import { PlayerProfileForm } from '../players/player-profile-form';
const UserButtonTrigger = ({
  onClick
}: {
  onClick: () => void;
}) => {
  const {
    data
  } = useSession();
  return <div className="flex cursor-pointer" onClick={onClick} data-sentry-component="UserButtonTrigger" data-sentry-source-file="user-menu.tsx">
      <Mascot displayMode="player" alt="Spikemark" variant="small" path={data?.user.image ?? ''} data-sentry-element="Mascot" data-sentry-source-file="user-menu.tsx" />
      <div className="flex flex-col pl-2 min-w-32">
        <p className="text-white text-sm font-medium">{data?.user.name}</p>
        <p className="text-gray-300 text-xs">{data?.user.email}</p>
      </div>
    </div>;
};
export const UserMenu = () => {
  const [playerProfileOpen, setPlayerProfileOpen] = useState(false);
  const userButtonRef = useRef<HTMLDivElement>(null);
  const handleTriggerClick = () => {
    // Find the button element within the UserButton and trigger a click
    const button = userButtonRef.current?.querySelector('button');
    if (button) {
      button.click();
    }
  };
  return <SignedIn data-sentry-element="SignedIn" data-sentry-component="UserMenu" data-sentry-source-file="user-menu.tsx">
      <UserButtonTrigger onClick={handleTriggerClick} data-sentry-element="UserButtonTrigger" data-sentry-source-file="user-menu.tsx" />
      <div ref={userButtonRef}>
        <UserButton appearance={{
        elements: {
          userButtonBox: {
            display: 'none'
          },
          userPreview__userButton: {
            display: 'none'
          }
        }
      }} userProfileMode="modal" userProfileProps={{
        appearance: {
          elements: {
            profileSection__profile: {
              display: 'none'
            },
            profileSection__activeDevices: {
              display: 'none'
            }
          }
        }
      }} data-sentry-element="UserButton" data-sentry-source-file="user-menu.tsx">
          <UserButton.MenuItems data-sentry-element="unknown" data-sentry-source-file="user-menu.tsx">
            <UserButton.Action label="Update Profile" labelIcon={<User2Icon className="w-4 h-4" />} onClick={() => setPlayerProfileOpen(true)} data-sentry-element="unknown" data-sentry-source-file="user-menu.tsx" />
            <UserButton.Action label="manageAccount" data-sentry-element="unknown" data-sentry-source-file="user-menu.tsx" />
          </UserButton.MenuItems>
        </UserButton>
      </div>
      <PlayerProfileForm title="Update Your Profile" description={<></>} open={playerProfileOpen} onClose={() => setPlayerProfileOpen(false)} onSubmit={() => {}} data-sentry-element="PlayerProfileForm" data-sentry-source-file="user-menu.tsx" />
    </SignedIn>;
};